<template>
  <div @click="openFolder();" class="FolderWidget lxn-w100 lxn-h100 lxn-overflow-hidden lxn-title lxn-cursor-pointer" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass, bgColorClass]">
    {{widget.name}}
    <!-- <div @click="openFolder();" class="FolderWidget-wrapper-svg lxn-w100 lxn-h100 lxn-cursor-pointer">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xmlns:v="https://vecta.io/nano" class="lxn-w100 lxn-h100">
        <path d="M26 32H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6z" fill="#ffffff"/>
        <path d="M14 16.667H9.333C8.597 16.667 8 17.264 8 18v4.667C8 23.403 8.597 24 9.333 24H14c.736 0 1.333-.597 1.333-1.333V18c0-.736-.597-1.333-1.333-1.333zm-.667 6H10A.67.67 0 0 1 9.333 22v-2.667H14V22a.67.67 0 0 1-.667.667zm9.334-6H18c-.736 0-1.333.597-1.333 1.333v4.667c0 .736.597 1.333 1.333 1.333h4.667c.736 0 1.333-.597 1.333-1.333V18c0-.736-.597-1.333-1.333-1.333zm-.667 6h-3.333A.67.67 0 0 1 18 22v-2.667h4.667V22a.67.67 0 0 1-.667.667z" :fill="widgetColor"/>
        <path d="M14 8H9.333C8.597 8 8 8.597 8 9.333V14c0 .736.597 1.333 1.333 1.333H14c.736 0 1.333-.597 1.333-1.333V9.333C15.333 8.597 14.736 8 14 8zm-.667 6H10a.67.67 0 0 1-.667-.667v-2.667H14v2.667a.67.67 0 0 1-.667.667zm9.334-6H18c-.736 0-1.333.597-1.333 1.333V14c0 .736.597 1.333 1.333 1.333h4.667c.736 0 1.333-.597 1.333-1.333V9.333C24 8.597 23.403 8 22.667 8zM22 14h-3.333a.67.67 0 0 1-.667-.667v-2.667h4.667v2.667A.67.67 0 0 1 22 14z" :fill="widgetColor"/>
      </svg>
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'FolderWidget',
  props: {
    index: Number
  },
  components: {
  },
  data: function () {
    return {
    }
  },
  mounted: function () {
  },
  computed: {
    widget: function () {
      if(this.index != -1){
        return this.$store.state.widgets[this.index];
      }else{
        return null;
      }
    },
    widgetColor: function () {
      if(this.index != -1){
        return this.$store.state.themeMainColors[this.widget.color];
      }else{
        return this.$store.state.themeMainColors[3];
      }
    },
    bgColorClass: function () {
      return "colorGradient" + this.widget.color;
    }
  },
  methods: {
    openFolder: function () {
      this.$router.push("/home/dashboard/" + this.widget.settings.path);
    }
  },
}
</script>

<style>
  .FolderWidget {
    color: #ffffff;
    font-size: 20px;
    padding: 10px;
  }
  .colorGradient0 {
    background: #36D1DC;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to bottom, #5B86E5, #36D1DC);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to bottom, #5B86E5, #36D1DC); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
  .colorGradient1 {
    background: #fe8c00;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to bottom, #f83600, #fe8c00);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to bottom, #f83600, #fe8c00); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
  .colorGradient2 {
    background: #ec008c;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to bottom, #fc6767, #ec008c);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to bottom, #fc6767, #ec008c); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
  .colorGradient3 {
    background: #FFE000;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to bottom, #c9cc0c, #FFE000);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to bottom, #c9cc0c, #FFE000); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
  .colorGradient4 {
    background: #56ab2f;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to bottom, #a8e063, #56ab2f);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to bottom, #a8e063, #56ab2f); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
</style>
